import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import confetti from 'canvas-confetti';

export type SuccessRewardModalProps = {
  open: boolean;
  onClose: () => void;
};

function fireRewardConfetti(theme: Theme) {
  const { secondary, primary } = theme.palette;
  const s200 = (secondary as unknown as Record<string, string | undefined>)['200'];
  void confetti({
    particleCount: 120,
    spread: 70,
    startVelocity: 35,
    origin: { x: 0.5, y: 0.45 },
    colors: [secondary.light, secondary.main, secondary.dark, s200 ?? secondary.light, primary.light].filter(
      Boolean,
    ) as string[],
    ticks: 200,
    gravity: 0.9,
    scalar: 1,
  });
}

const SuccessRewardModal: React.FC<SuccessRewardModalProps> = ({ open, onClose }) => {
  const theme = useTheme();

  useEffect(() => {
    if (open) {
      fireRewardConfetti(theme);
    }
  }, [open, theme]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="onboarding-reward-title"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          textAlign: 'center',
          border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
        },
      }}
    >
      <DialogTitle id="onboarding-reward-title" sx={{ fontWeight: 800, color: 'secondary.dark', pt: 3 }}>
        מזל טוב!
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography variant="body1" color="text.primary" sx={{ lineHeight: 1.65 }}>
          עמדתם באתגר! חודש חינם נוסף עודכן בחשבונכם.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2.5, px: 2 }}>
        <Button variant="contained" color="secondary" onClick={onClose} size="large" sx={{ borderRadius: '9999px', px: 3 }}>
          סגור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessRewardModal;
